import type { RouteRecordRaw } from 'vue-router';
export const projectsRoutes: RouteRecordRaw[] = [
  {
    path: 'projects',
    name: 'projects',
    component: () => import('../pages/projects/ProjectsPage.vue'),
    meta: { requiresModule: 'projects' },
  },
];
